export const REPORT_CATEGORY = {
    All: "all",
    Actionable: "actionable",
    Preview: "preview",
    Completed: "completed",
} as const;

export type ReportCategory = (typeof REPORT_CATEGORY)[keyof typeof REPORT_CATEGORY];
